import { SousLogo } from "@withsous/common";

export default function Hero() {
  return (
    <section className="pt-32 pb-20 px-6">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col items-center text-center">
          <div className="mb-8 flex items-center justify-center">
            <SousLogo size={120} className="text-primary-600" />
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-neutral-900 mb-6">
            Your Kitchen,
            <br />
            <span className="text-primary-600">Simplified</span>
          </h1>
          <p className="text-xl md:text-2xl text-neutral-600 mb-12 max-w-3xl">
            Transform recipe photos into organized meal plans. Scan, save, and cook with AI-powered
            recipe management.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://withsous.app"
              className="px-8 py-4 bg-primary-600 text-white text-lg font-semibold rounded-lg hover:bg-primary-700 transition shadow-lg hover:shadow-xl"
            >
              Start Cooking Smarter
            </a>
            <a
              href="#features"
              className="px-8 py-4 bg-white text-primary-600 text-lg font-semibold rounded-lg hover:bg-neutral-50 transition border-2 border-primary-600"
            >
              Learn More
            </a>
          </div>
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <p className="text-4xl font-bold text-primary-600 mb-2">10,000+</p>
              <p className="text-neutral-600">Recipes Saved</p>
            </div>
            <div>
              <p className="text-4xl font-bold text-primary-600 mb-2">5,000+</p>
              <p className="text-neutral-600">Happy Cooks</p>
            </div>
            <div>
              <p className="text-4xl font-bold text-primary-600 mb-2">99%</p>
              <p className="text-neutral-600">OCR Accuracy</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
